/**
 * useJournal Hook
 * React Query hook for managing a single journal
 */

import { useQuery } from '@tanstack/react-query';
import { getJournal } from '@/services/journalService';

/**
 * Fetch a single journal by ID
 */
export function useJournal(journalId: string | undefined) {
  return useQuery({
    queryKey: ['journal', journalId],
    queryFn: async () => {
      if (!journalId) throw new Error('Journal ID is required');
      return getJournal(journalId);
    },
    enabled: !!journalId,
  });
}





